import { QuickVerticalTable, QuickHorizontalTable } from "components/molecules/QuickTable";
import useQueryMeasure from "ApiLayer/Measures/queryMeasure";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { useParams } from "react-router-dom";
import { FinancialImpact } from "./Cards/FinancialImpact";
import MeasureReportHeader from "./Cards/MeasureReportHeader";
import PerformanceImpact from "./Cards/PerformanceImpact";
import "./ProjectsReport.scss";
import MeasureAnalysis from "./MeasureAnalysis";

function MeasureReportProvider() {
    const { carbonReductionMeasureUid } = useParams();
    const { data: measure, isLoading: isMeasureLoading } = useQueryMeasure(
        carbonReductionMeasureUid || "no-measure-uid-found-in-url"
    );

    if (carbonReductionMeasureUid === undefined) {
        return <>Missing carbon reduction measure uid in URL.</>;
    }

    if (isMeasureLoading) return <LoadingSpinner />;

    if (measure === null || measure === undefined) {
        return <>Could not find Measure with ID: {carbonReductionMeasureUid}</>;
    }
    return <MeasureReport measure={measure as CarbonReductionMeasure} />;
}

interface MeasureReportProps {
    measure: CarbonReductionMeasure;
}

export function MeasureDebugging({ measure }: { measure: CarbonReductionMeasure }) {
    const plan = measure.carbonReductionPlan;
    const annualSummaries = plan.annualSummaries;

    return (
        <QuickVerticalTable
            theKeyAttribute="year"
            theObjs={annualSummaries}
            showOnlyKeys={["utilityCostSavingsElectricity", "utilityCostSavingsNaturalGas"]}
        />
    );
}

export function MeasureReport({ measure }: MeasureReportProps) {
    const measureAnalyses = measure.measureAnalyses.sort((a, b) => a.id - b.id);

    return (
        <div className="project-report">
            <MeasureReportHeader measure={measure} />
            <FinancialImpact measure={measure} />
            <PerformanceImpact measure={measure} />
            <div style={{ display: "none" }}>
                {/* I just want to be able to see this in the source for debugging if needed */}
                {measureAnalyses.map((measureAnalysis) => (
                    <MeasureAnalysis measureAnalysis={measureAnalysis} measure={measure} key={measureAnalysis.id} />
                ))}
            </div>
            <div style={{ display: "none" }}>
                <MeasureDebugging measure={measure} />
            </div>
        </div>
    );
}

export default MeasureReportProvider;
